var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "blog-card",
            on: {
              click: function($event) {
                return _vm.showDetail(_vm.item.id)
              }
            }
          },
          [
            _c("section", { staticClass: "img" }, [
              _c("img", {
                staticClass: "img-card",
                attrs: { src: _vm.item.post_image_url, alt: "" }
              })
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "content" }, [
              _c("div", { staticClass: "title-card" }, [
                _vm._v(_vm._s(_vm.item.id) + _vm._s(_vm.item.post_title))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "description-crad" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.removeHTMLTags(_vm.item.post_content)))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-crad" }, [
                _c("div", { staticClass: "created-by" }, [_vm._v("By BeNeat")]),
                _vm._v(" "),
                _c("div", [
                  _c("i", { staticClass: "time" }),
                  _vm._v(
                    _vm._s(_vm._f("prettyOnlyDateBE")(_vm.item.updated_at))
                  )
                ])
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dde696d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dde696d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blogs/components/CardBlog.vue
// module id = 2396
// module chunks = 0